import { USER_API_URL, MAPPING_API_URL, ADMIN_USER_API_URL, PASSWORD_POLICY_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const UserServices = {
  fetchUserDetails: async (params: any) => {
    const response = await axiosClient.get(`${USER_API_URL}`, {
      params
    });

    return response.data;
  },

  fetchUsers: async (
    page?: any,
    rowsPerPage?: any,
    userName?: string,
    domainName?: string,
    roleType?: string,
    roleName?: string,
    groupId?: string,
    roleId?: string,
    organizationName?: string,
    organizationId?: string,
    appName?: any,
    appType?: any
  ) => {
    const response = await axiosClient.get(`${USER_API_URL}`, {
      params: {
        domainName: domainName,
        pageNumber: page,
        pageSize: rowsPerPage,
        userName,
        roleType,
        roleName,
        groupId,
        roleId,
        organizationName,
        organizationId,
        appName,
        appType
      }
    });
    return response.data;
  },

  createUser: async (body: any) => {
    try {
      const response = await axiosClient.post(`${USER_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deleteUser: async (userId: any, domain_name: string, org_name: string) => {
    try {
      const response = await axiosClient.delete(`${USER_API_URL}`, {
        params: {
          userId,
          domainName: domain_name,
          organizationName: org_name
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  bulkDeleteUser: async (data: any) => {
    try {
      const response = await axiosClient.delete(`${USER_API_URL}/bulk`, {data});
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  updateUser: async (body: any, userId: 'string') => {
    try {
      const response = await axiosClient.put(`${USER_API_URL}/${userId}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  getPasswordPolicy: async (body: any) => {
    try {
      const response = await axiosClient.get(`${PASSWORD_POLICY_URL}`, {
        params: {
          dom_name: body.domainName,
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  lockUser: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ADMIN_USER_API_URL}/lock-status`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  suspendUser: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ADMIN_USER_API_URL}/suspend-status`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  recoverPassword: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ADMIN_USER_API_URL}/recover-password`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadUser: async () => {
    try {
      const response = await axiosClient.get(`${USER_API_URL}/download`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  mappingUser: async (body: any) => {
    try {
      const response = await axiosClient.post(`${MAPPING_API_URL}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  uploadCsv: async (params: any) => {
    try {
     
      const response = await axiosClient.post(`${USER_API_URL}/upload/csv`, {
          dom_name: params?.dom_name,
          created_by: params?.created_by,
          modified_by: params?.modified_by,
          ask_password: params?.ask_password,
          status: params?.status,
          data: params?.data
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  }
};

export default UserServices;
